
export default function FilledInput(theme) {
    return {
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "#F5F6FA",
                    borderRadius: "8px",
                    border: "1px solid #D1D5DB",

                    ".MuiFilledInput-input": {
                        color: "#6B7280",
                        padding: "10px",

                        "&::placeholder": {
                            color: "#6B7280",
                        },
                    },

                    "&.MuiFilledInput-root::before, &.MuiFilledInput-root::after": {
                        content: "none"
                    },

                    "&.Mui-error": {
                        border: "1px solid #e23c27"
                    },
                },
            },
        },
    };
}